import HttpClient from "../HttpClient";

export interface CookLocationPoint {
  type: "Point";
  coordinates: [number, number];
}

export interface VisitInfo {
  id: number;
  time: string;
  status: string;
  checkInTime?: string | null;
  houseId: number;
  houseCoordinates: {
    lat: number;
    long: number;
  };
}

export interface RecentCookLocationResponse {
  cookId: number;
  cookName: string;
  currentLocation: CookLocationPoint | null;
  currentLocationCreatedAt: string | null;
  previousLocation: CookLocationPoint | null;
  previousLocationCreatedAt: string | null;
  isCookMoving: boolean;
  ongoingVisit: VisitInfo | null;
  nextVisit: VisitInfo | null;
}

export type CookServiceStatusFilter =
  | "COOK_CONFIRMED"
  | "ONGOING"
  | "FULFILLED";

export default class CookLiveLocationService {
  async getRecentCookLocations(serviceStatus?: CookServiceStatusFilter) {
    const response = await HttpClient.get<RecentCookLocationResponse[]>(
      "/centaurus/cook/get-recent-cook-locations",
      {
        params: {
          ...(serviceStatus ? { serviceStatus } : {}),
        },
      }
    );

    return response.data || [];
  }
}
